import { HeadsetIcon } from '@phosphor-icons/react'
import { Trans, useTranslation } from 'react-i18next'
import { useSearchParams } from 'react-router-dom'

import { useVisitorParkingAnalytics } from '@/pages/visitor-parking/visitor-parking.hooks'

import {
  getHelpSectionUrl,
  HELP_SECTION_EMAIL,
  TICKET_NUMBER_URL_KEY,
} from './help-section.constants'
import * as S from './help-section.styled'

export const HelpSection = () => {
  const { t } = useTranslation(['visitor-parking'])
  const [searchParams] = useSearchParams()
  const ticketNumber = searchParams.get(TICKET_NUMBER_URL_KEY)
  const { handleTrackSupportRequest } = useVisitorParkingAnalytics()

  return (
    <S.HelpSection>
      <S.Content>
        <S.Icon icon={HeadsetIcon} size="2.4rem" />
        <S.Title>{t('visitor-parking:helpSection.title')}</S.Title>
      </S.Content>
      <S.Description>
        <Trans
          components={[
            <S.Link href={getHelpSectionUrl(ticketNumber)} onClick={handleTrackSupportRequest} />,
          ]}
          i18nKey="helpSection.description"
          ns="visitor-parking"
          values={{ email: HELP_SECTION_EMAIL }}
        />
      </S.Description>
    </S.HelpSection>
  )
}
